import React from "react";

export const EmptyCellRenderer = () => <></>;
